<template>
        <div style="margin-left: 12px; position: relative">   
           <!--  <div v-if="cardsView"> -->
                <div :class="{wobuCardInbox: $parent.isInbox, wobuCard: !$parent.isInbox, wobuOGCard: isOGshare, grayOut: grayOut} "   >
                     <div v-show="isPush || isUpd" class="includeInPushWrapper">
                        <div>
                            <b class="is-size-7">&nbsp;Include:</b>&nbsp;<input type="checkbox" checked @click="toggleChecked" ref="checkBox">
                        </div>
                        </div>
                    <div>
                       
                      <!--    <div class="is-size-7 has-background-black has-text-white has-text-centered colorLeft handCursor topRoundCorners" :class="{both: !$parent.$parent.showContext && !isSB && !isOGshare}">
                            <span>{{item.site}}</span>
                          
                        </div> -->
                        <a :href="item.url" target="_blank">
                            <div class="cardImgContainer handCursor" :class="{cardImgContainerHeight: !collapsed && !isOGshare, cardImgContainerHeightOG: isOGshare}">
                                <img v-show="!collapsed && loaded" :src="item.img || defImg"  @load="imgHasLoaded" @error="imgError">
                                <img v-show="overlay && !collapsed" class="miimuDefOverlaySmall"  :src="overlayImg"/>
                            </div>  
                       </a>

                       
                    </div>
                    <rater class="handCursor" v-show="$root.app.showImages" :isCollab="$parent.conts.collabId ? true : false" :ratingMy="ratingMy" :topBox="$parent.conts.collabId ? ratingAvg : ratingMy" v-if=" $root.app.showRatings && $parent.$parent.componentName == 'modalBundle'"></rater>


                        <div class="posRelative">
    
                            <div v-show="!isOGshare" :class="{top20: inFeed && collapsed }">
                                <div class="cardTitleBG posRelative">
                                    <div class="is-inline-block cardTitAndDesc"> <!-- style="width: 170px" -->
                                        <div class="cardTitle top5">{{item.title || '&nbsp;'}}</div>
                                         <div class="cardDescription">{{item.description || '&nbsp;'}}</div>
                                          <div class="cardDescription has-text-grey">{{item.site || '&nbsp;'}}</div>
                                    </div>
                               
    
                                <div v-if="menuVisible" class="cardMenu has-text-left">
                                        <div class="cardMenuItem" @click="openComments()">
                                          <i class="fa fa-comment"></i>&nbsp;&nbsp;Comments
                                        </div> 
                                        <div class="cardMenuItem top10" @click="openEdit()">
                                            <i class="fa fa-arrow-down"></i>&nbsp;&nbsp;Import
                                        </div> 
                                       
                                    
                                </div> 
            
                                    <div class="is-inline-block vTop" @click.prevent="showMenu">
                                        <div class="cardVEllipsis"><b>&vellip;</b></div>
                                    </div>
                                 </div>
                            </div>

                         

                            <div v-show="isOGshare">
                                <div class="is-inline-block has-text-left pad5"> <!-- style="width: 170px" -->
                                    <div class="cardTitle is-size-6 top10">{{item.title || '&nbsp;'}}</div>
                                    <div class="top5 left5 is-size-7">{{item.description || '&nbsp;'}}</div>
                                    <div class="cardDescription has-text-grey top5">{{item.site || '&nbsp;'}}</div>
                                </div>

                                 <!--    <div class="top10  bottom20">
                                        <button class="button is-coolGreen is-small" @click="navigate">
                                            <b>Visit Link</b>
                                        </button>&nbsp;&nbsp;&nbsp;
                                  
                                        <button class="button is-coolGreen is-small" @click="openEdit()">
                                            <b>Import</b>
                                        </button> 
                                    </div> -->
                                  
                            </div> 
        
                            
                    </div>
                    
                    
                
                </div>
                <div v-if="((!$parent.$parent.isInbox && $parent.$parent.showContext || isOGshare || isSB) && item.note) || (inFeed && !collapsed)" class="cardContext sharedAdjust" :class="{inOG: isOGshare}">
                    <div v-linkified style="height: 130px; overflow: auto" v-html="item.note || 'no notes'" class="has-text-left has-text-coolGreen"></div>
                </div>
                <div v-if="!$parent.$parent.isInbox && $parent.$parent.showContext && !item.note && !inFeed" class="cardContextEmptyShared">
                    <div class="verticalNotes has-text-centered"></div>
                </div>
               <!--  <div v-if="sponsored" class="sponsoredTitle">sponsored</div> -->
               
        </div>

       
</template>

<script>

import { AZEventBus } from '../components/AZEventBus'
import defImages from '../static/defimages'
import Rater from './Rater.vue'

export default {
    props: {
        cardInfo: Object,
        shareId: Number,
        sel: {
            type: Boolean,
            default: true
        },
        isPublic: {
            type: Boolean,
            default: false
        },
        inFeed: {
            type: Boolean,
            default: false
        },
        sponsored:{
            type: Boolean,
            default: false
        },
        collapsed: {
            type: Boolean,
            default: false
        }
    },

    components: {Rater},
    data: function(){
        return {
            loaded: false,
            menuVisible: false,
            isPush: this.$parent.$parent.isPush,
            isUpd: this.$parent.$parent.upd,
            grayOut: false,
            isOGshare: false,
            isSB: false,
            overlayImg: '',
            componentName: 'cardShared'
        }
    },

    mounted: function(){

        var self = this

        if(this.$route.path == '/og/og'){
            this.isOGshare = true
        }

         if(this.$route.path == '/sb'){
            this.isSB = true
        }

        if(this.isPush){
            this.item =  this.$root.app.cards[this.item.cardsIndex];
        }


        AZEventBus.$on('closeAllMenus', this.closeAllMenusHandler)
        
    },

    beforeDestroy: function(){
        var self = this;
        AZEventBus.$off('closeAllMenus', this.closeAllMenusHandler)
    },

    methods: {
        closeAllMenusHandler: function(msg){
            this.menuVisible = false
        },

        imgHasLoaded: function(){
            this.loaded = true;
            this.dragging = false;
            //remove
        },
        navigate: function(){
            window.open(this.item.url);
        },
        showMenu: function(event){
            event.stopPropagation()
            this.menuVisible = true
        },
        openEdit: function(){
            if(!this.$root.app.isAuth){
                this.$root.app.showModalLogin()
                return
            }
            this.item.shareId = this.shareId
            this.$root.app.doShowModal('editModal', {cardPack: this.item, callApi: false})
        },
        imgError: function(){
            this.item.img = this.defImg
        },
        toggleChecked: function(){
            
            if(!this.grayOut){
                this.grayOut = true
                this.$parent.$parent.unInclude(this.item.id)
                //this.$refs.checkBox.attributes.checked = false
            } else {
                this.grayOut = false
                this.$parent.$parent.include(this.item.id)
                //this.$refs.checkBox.attributes.checked = true
            }
        },
        checkIt: function(){
            this.grayOut = false
            this.$parent.$parent.include(this.item.id)
            
        },
        uncheckIt: function(){
            this.grayOut = true
            this.$parent.$parent.unInclude(this.item.id)
            
        },

        openComments: function(){
            this.$root.app.openComments(this.item, this.$parent.data.id, null)
        }
    },
    computed: {
          item: { 

            get: function(){
           
                var temp = {url: ''}
                if(this.isPublic){
                    temp = this.$parent.$parent.cards[this.cardInfo.cardsIndex]
                } else if(this.upd){

                } else if(this.isPush) {
                    temp = this.$root.app.cards[this.cardInfo.cardsIndex];
                } else {
                    temp = this.cardInfo
                }

                var self = this

                function setGrayState(){
                    var compareB = self.$parent.$parent.upd ? temp.importedBundleId : self.$parent.info.id

                    for(var i=0; i < self.$parent.$parent.toIgnore.length; i++){
                        if((self.$parent.$parent.toIgnore[i].id == temp.id && self.$parent.$parent.toIgnore[i].b == compareB) || self.sel == false){
                            self.grayOut = true
                            self.$refs.checkBox.checked = false 
                            break;
                        } else {
                            self.grayOut = false
                            self.$refs.checkBox.checked = true 
                        }
                    }
                }

                if(self.$parent.$parent.upd || self.$parent.$parent.isPush)
                    setTimeout(setGrayState, 20)
                
                //if(this.currImg != temp.img) this.loaded = false;
                return  temp || {title: '', site: '', cardsIndex: '', url: ''};
            },

           /*  set: function(newVal){

            } */
            
        },

        ratingMy: function(){
            if(!this.item.myRatings){
                return 0
            }

            var theId = this.$parent.conts.aliasTgtId || this.$parent.conts.id;

            let r = this.item.myRatings.find(e => {
                return e.collabId == theId
            })  
           

            if(r){
                return r.rating
            } else {
                return 0
            } 
        },
        ratingAvg: function(){
            if(!this.item.avgRatings){
                return 0
            }
            var theId = this.$parent.conts.aliasTgtId || this.$parent.conts.id;
            let r = this.item.avgRatings.find(e => {
                return e.collabId == theId
            })

            if(r){
                return r.rating
            } else {
                return 0
            } 
        },

        cardsIndex: {
            get: function(){
                return this.theCardsIndex
            },

            set: function(newVal){
               
            }   
        },
        defImg: function(){
            //return require('@/assets/img/miiMuDefault.jpg');
            return `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-default.png`
        },
        overlay: function(){

            var temp2 = az.overlaySorter(this.item.site, this.item.url, this.item.img)
            this.overlayImg = defImages.overlays[temp2]
            return temp2

           /*  if(this.item.img.substring(0, 46) == 'https://miimuimg.s3.amazonaws.com/m-ii-default'){
                this.overlayImg = ''
                return false
            } else if(this.item.img.substring(0, 43) == 'https://miimuimg.s3.amazonaws.com/m-ii-BGbg'){
               
                var temp = az.overlaySorter(this.item.site, this.item.url, this.item.img)
                this.overlayImg = defImages.overlays[temp]
                return temp
            }

            return false */
        },
        /* source: function(){
            if(this.item.site == 'www.facebook.com' || this.item.site == 'facebook.com'){
                return `<img src="${require('@/assets/img/facebook.png')}" width="22">`
            } else if(this.item.site == 'www.instagram.com' || this.item.site == 'instagram.com'){
                return `<img src="${require('@/assets/img/instagram.png')}" width="22">`
            } else if(this.item.site == 'www.twitter.com' || this.item.site == 'twitter.com'){
                return `<img src="${require('@/assets/img/twitter.png')}" width="22">`
            } else if(this.item.site == 'www.youtube.com' || this.item.site == 'youtube.com'){
                return `<img src="${require('@/assets/img/youtube.png')}" width="22">`
            } 
            
            
            
            else {
                return ''
            }
        } */
    }    
}

</script>